import styled from "styled-components";
import { textFieldFocus } from "globalStyles";

export const Input = styled.input`
    width: 100%;
    height: 40px;
    padding: 6px 12px;
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    border: 1px solid #ccc;
    box-sizing: border-box;
    &:focus {
        ${textFieldFocus()}
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
